import React, { useMemo, useState } from "react";
import {
  Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControlLabel, Grid, MenuItem, Stack, TextField, Typography
} from "@mui/material";
import { menuApi } from "../utils/menuApi";

const ReplicateMenuDialog = ({
  open,
  onClose,
  locations,
  targetLocationId,
  token,
  clientId,
  menuTree,
  onSuccess,
  showSnackbar,
}) => {
  const [sourceLocationId, setSourceLocationId] = useState("");
  const [overwrite, setOverwrite] = useState(false);
  const [selectedFoodTypeIds, setSelectedFoodTypeIds] = useState([]);

  const sourceOptions = useMemo(
    () => locations.filter((loc) => loc.id !== targetLocationId),
    [locations, targetLocationId]
  );

  const currentFoodTypes = menuTree?.menu || [];

  const handleToggleFoodType = (id) => {
    setSelectedFoodTypeIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleReplicate = async () => {
    if (!sourceLocationId) {
      showSnackbar("Please select a source location", "error");
      return;
    }

    const payload = {
      source_location_id: sourceLocationId,
      overwrite,
      ...(selectedFoodTypeIds.length ? { food_type_ids: selectedFoodTypeIds } : {}),
    };

    try {
      await menuApi.replicateMenu({
        token,
        clientId,
        locationId: targetLocationId,
        payload,
      });
      showSnackbar("Menu replicated successfully");
      onSuccess();
    } catch (error) {
      showSnackbar(error?.response?.data?.detail || "Failed to replicate menu", "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Replicate Menu</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField
              select
              fullWidth
              label="Source Location"
              value={sourceLocationId}
              onChange={(e) => setSourceLocationId(e.target.value)}
            >
              {sourceOptions.map((loc) => (
                <MenuItem key={loc.id} value={loc.id}>
                  {loc.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox checked={overwrite} onChange={(e) => setOverwrite(e.target.checked)} />}
              label="Overwrite target menu before copying"
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              Copy selected food types only (leave all unchecked to copy full menu)
            </Typography>
            <Stack>
              {currentFoodTypes.map((ft) => (
                <FormControlLabel
                  key={ft.id}
                  control={
                    <Checkbox
                      checked={selectedFoodTypeIds.includes(ft.id)}
                      onChange={() => handleToggleFoodType(ft.id)}
                    />
                  }
                  label={ft.name}
                />
              ))}
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleReplicate}>
          Replicate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReplicateMenuDialog;